module.exports = "<div class=\"image-container\" [style.background-image]=\"'url(' + (media.url | urlEncode) +')'\">\n</div>\n"